function moveReactBlock() {
  const box = document.querySelector(".c-move-react-box__box");
  const image = box.querySelector(".c-move-react-box__img");
  if (box) {
    box.addEventListener("mousemove", function (e) {
      const rect = box.getBoundingClientRect();
      const x = (e.clientX - rect.left) / 2; // Cursor position X within block
      const y = e.clientY - rect.top; // Y position of the cursor within the block

      // Calculate the percentage of the cursor position inside the block
      const xPercent = x / rect.width;
      const yPercent = y / rect.height;

      // console.log(yPercent);

      // Maximum displacements
      const maxOffsetX = 50; // Max horizontal offset (px)
      const maxOffsetY = 50; // Max vertical offset (px)

      // Calculate offsets (in the opposite direction from mouse movement)
      const offsetX = Math.round((0.2 - xPercent) * 2 * maxOffsetX);
      const offsetY = Math.round((0.2 - yPercent) * maxOffsetY);

      // Apply transformation to the image
      image.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
    });

    box.addEventListener("mouseleave", function () {
      // Resetting the image position when the cursor leaves the block
      image.style.transform = "translate(0, 0)";
    });
  }
}

export default moveReactBlock;
